import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version,
  production: false,
  logLevel: 2,
  timezone: "America/New_York",
  b2bAuthUrl: 'https://api.fitsvc.dev/api/v2/',
  b2bUrl: 'https://api.fitsvc.dev/api/v1/',
  b2bApiVersion: '1.0'
};

/*
 * logLevel 1 = DEBUG
 * logLevel 2 = INFO
 * logLevel 3 = WARNING
 * logLevel 4 = ERROR
 * logLevel 5 = FATAL/CRITICAL
 */